import { Button } from "@relex-solutions/fragments"
import { useTranslation } from "react-i18next"
import { ErrorBoundaryContent } from "../errorBoundaryContent/ErrorBoundaryContent"
import styles from "./ErrorComponent.module.css"

interface ErrorComponentProps {
  error: Error | null
  onRetry?: () => void
  buttonLabel?: string
  hideIconAndTitle?: boolean
}

export function ErrorComponent({ error, onRetry, buttonLabel, hideIconAndTitle = false }: ErrorComponentProps) {
  const { t } = useTranslation()
  return (
    <div className={styles.errorContainer} data-testid="error-component">
      <ErrorBoundaryContent error={error} hideIconAndTitle={hideIconAndTitle} />
      {onRetry && <Button onClick={onRetry}>{buttonLabel ?? t("errorBoundary.button")}</Button>}
    </div>
  )
}
